import { Link } from 'wouter'

interface Props {
  feedId: FeedId
  title: string
  unreadCount: number
  isSelected: boolean
  alwaysShow: boolean
  onRefresh: () => void
}

export default function Feed({
  feedId,
  title,
  unreadCount,
  isSelected,
  alwaysShow,
  onRefresh,
}: Props) {
  // Hide feeds with no unread stories unless selected or always shown
  if (!alwaysShow && !isSelected && unreadCount === 0) {
    return null
  }

  const href = feedId === 0 ? '/' : `/feed/${feedId}`

  return (
    <li className={isSelected ? 'active' : ''}>
      <Link href={href}>
        {title}
        {feedId !== 0 && <span className="unread"> ({unreadCount})</span>}
      </Link>
      {isSelected && (
        <button
          aria-label="Refresh feed"
          className="refresh"
          onClick={(e) => { e.stopPropagation(); onRefresh(); }}
          title="Refresh"
        >
          ↻
        </button>
      )}
    </li>
  )
}
